const messages = {
  it: {
    translations: {

      signup: {
        title: "Registrati",
        toasts: {
          success: "Utente creato con successo! Accedi!",
          fail: "Errore nella creazione dell'utente. Verifica i dati inseriti."
        },
        form: {
          name: "Nome",
          email: "E-mail",
          password: "Password",
          company: "Nome dell'Organizzazione",
          phone: "WhatsApp (Prefisso + NUMERO)"
        },
        buttons: {
          submit: "Registrati",
          login: "Hai già un account? Accedi!"
        }
      },
      login: {
        title: "Accedi",
        form: {
          email: "E-mail",
          password: "Password",
          button: "Accedi"
        },
        buttons: {
          submit: "Accedi",
          register: "Non hai un account? Registrati!"
        }
      },
      companies: {
        title: "Registra Azienda",
        form: {
          name: "Nome dell'Azienda",
          plan: "Piano",
          token: "Token",
          submit: "Registra",
          success: "Azienda creata con successo!"
        }
      },
      registerClient: {
        title: "Registra cliente",
        subtitle: "Crea un nuovo account cliente e imposta il piano iniziale.",
        steps: {
          company: "Azienda",
          contact: "Contatto",
          plan: "Piano e moduli"
        },
        toasts: {
          stepCompanyRequired: "Compila nome, email e telefono dell'azienda.",
          stepContactRequired: "Compila nome ed email del contatto.",
          success: "Cliente registrato con successo.",
          error: "Impossibile registrare il cliente."
        },
        industries: {
          retail: "Retail",
          restaurant: "Ristorante",
          healthcare: "Sanita",
          education: "Istruzione",
          technology: "Tecnologia",
          services: "Servizi",
          ecommerce: "Ecommerce",
          realEstate: "Immobiliare",
          other: "Altro"
        },
        company: {
          title: "Dati azienda",
          fields: {
            name: "Nome azienda",
            industry: "Settore",
            email: "Email aziendale",
            phone: "Telefono aziendale",
            address: "Indirizzo",
            website: "Sito web"
          }
        },
        contact: {
          title: "Referente",
          fields: {
            name: "Nome completo",
            position: "Ruolo",
            email: "Email",
            phone: "Telefono"
          }
        },
        plan: {
          title: "Piano e fatturazione",
          perMonth: "/mese",
          includes: {
            users: "Utenti",
            connections: "Connessioni",
            queues: "Aree"
          },
          billingCycle: "Ciclo di fatturazione",
          billingMonthly: "Mensile",
          billingAnnual: "Annuale (2 mesi gratis)"
        },
        addons: {
          title: "Moduli aggiuntivi",
          pricePerMonth: "$ {{amount}}/mese"
        },
        notes: {
          title: "Note interne",
          placeholder: "Scrivi note per il team commerciale..."
        },
        total: {
          label: "Totale stimato",
          perMonth: " /mese",
          perYear: " /anno"
        },
        buttons: {
          back: "Indietro",
          next: "Avanti",
          submit: "Registra cliente"
        }
      },
      auth: {
        toasts: {
          success: "Accesso effettuato con successo!"
        },
        dueDate: {
          expiration: "Il tuo abbonamento scade tra",
          days: "giorni!",
          day: "giorno!",
          expirationToday: "Il tuo abbonamento scade oggi!"
        },
        token: "Token"
      },
      dashboard: {
        title: "Pannello di Controllo",
        buttons: {
          filter: "Filtra"
        },
        tabs: {
          indicators: "Indicatori",
          assessments: "NPS",
          attendants: "Agenti",
          performance: "Performance"
        },
        charts: {
          performance: "Grafici",
          userPerformance: "Grafico degli Utenti",
          perDay: {
            title: "Servizi oggi: "
          }
        },
        cards: {
          inAttendance: "In Assistenza",
          waiting: "In Attesa",
          activeAttendants: "Agenti Attivi",
          finalized: "Finalizzati",
          newContacts: "Nuovi Contatti",
          totalReceivedMessages: "Messaggi Ricevuti",
          totalSentMessages: "Messaggi Inviati",
          averageServiceTime: "T.M. di Assistenza",
          averageWaitingTime: "T.M. di Attesa",
          status: "Stato (Attuale)",
          activeTickets: "Ticket Attivi",
          passiveTickets: "Ticket Passivi",
          groups: "Gruppi"
        },
        users: {
          name: "Nome",
          numberAppointments: "Numero di Servizi",
          statusNow: "Attuale",
          totalCallsUser: "Totale servizi per utente",
          totalAttendances: "Totale servizi",
          totalLabel: "Totale servizi: {{count}}",
          queues: "Code",
          defaultQueue: "Connessione Predefinita",
          workingHours: "Orario di Lavoro",
          startWork: "Inizio Lavoro",
          endWork: "Fine Lavoro",
          farewellMessage: "Messaggio di Commiato",
          theme: "Tema Predefinito",
          menu: "Menu Predefinito",
        },
        date: {
          initialDate: "Data Iniziale",
          finalDate: "Data Finale"
        },
        licence: {
          available: "Disponibile fino al"
        },
        assessments: {
          totalCalls: "Totale Servizi",
          callsWaitRating: "Servizi in attesa di valutazione",
          callsWithoutRating: "Servizi senza valutazione",
          ratedCalls: "Servizi valutati",
          evaluationIndex: "Indice di valutazione",
          score: "Punteggio",
          prosecutors: "Promotori",
          neutral: "Neutri",
          detractors: "Detrattori"
        }
      },
      surveyReports: {
        title: "Rapporto dei Sondaggi Realizzati",
        operator: "Operatore",
        period: "Periodo",
        until: "Fino al",
        date: "Data",
        reportTitle: "Rapporti",
        calls: "Servizi",
        search: "Sondaggi",
        durationCalls: "Durata dei Servizi",
        grupoSessions: "Servizi nei Gruppi",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generazione del rapporto compresso, attendere prego.",
          errorToast: "Errore nella generazione del rapporto",
          back: "Indietro",
          groupServiceReport: "Rapporto dei Servizi nei Gruppi",
          loading: "Caricamento...",
          contact: "Contatto",
          dateOpen: "Data di Apertura",
          dateLastUpdated: "Data di Ultimo Aggiornamento",
          agent: "Chi ha Servito",
          agentClosed: "Chi ha Chiuso",
          waitingAssistance: "In Attesa di Assistenza",
          process: "In Assistenza"
        },
        researchReports: {
          response: "risposta",
          active: "(Attivo)",
          inactive: "(Inattivo)",
          quantity: "Quantità",
          percentage: "percentuale",
          title: "Rapporto dei Sondaggi Realizzati",
          activeSearch: "Sondaggio attivo",
          inactiveSearch: "Sondaggio inattivo"
        },
        ticketDurationDetail: {
          msgToast: "Generazione del rapporto compresso, attendere prego.",
          title: "Rapporto di Durata del Servizio",
          startService: "Inizio del Servizio",
          lastUpdated: "Ultimo Aggiornamento",
          lastAgent: "Ultimo Agente",
          durationFinished: "Durata dopo la finalizzazione"
        },
        ticketDuration: {
          title: "Rapporto di Durata dei Servizi",
          contact: "Contatto",
          open: "Aperti",
          pending: "In Attesa",
          finished: "Finalizzati",
          durationFinished: "Durata dei finalizzati",
          durationAfterFinished: "Durata dopo la finalizzazione",
          actions: "Azioni"
        },
        ticketReports: {
          msgToast: "Generazione del rapporto compresso, attendere prego.",
          title: "Rapporto dei Servizi"
        },
        pdf: {
          title: "Relazione dei Servizi Realizzati",
          exportTitle: "Relazione dei Servizi nei Gruppi Realizzati"
        }
      },
      todo: {
        newTask: "Nuovo Compito",
        add: "Aggiungi",
        task: "Compiti"
      },
      contactImportWpModal: {
        title: "Esporta Contatti in Excel",
        buttons: {
          downloadModel: "Scarica modello Excel per l'importazione",
          closed: "Chiudi",
          import: "Seleziona il file Excel per importare i Contatti"
        }
      },
      companyWhatsapps: {
        title: "Connessioni di: {{name}}",
      },
      connections: {
        title: "Connessioni",
        waitConnection: "Attendere... Le tue connessioni si riavvieranno!",
        newConnection: "Nuova Connessione",
        restartConnections: "Riavvia Connessioni",
        callSupport: "Chiama Supporto",
        toasts: {
          deleted: "Connessione eliminata con successo!",
          closedimported: "Stiamo chiudendo i ticket importati, attendere qualche istante"
        },
        confirmationModal: {
          closedImportedTitle: "Chiudi ticket importati",
          closedImportedMessage: "Se confermi, tutti i ticket importati verranno chiusi",
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata.",
          disconnectTitle: "Disconnetti",
          disconnectMessage: "Sei sicuro? Dovrai leggere nuovamente il codice QR."
        },
        buttons: {
          add: "Aggiungi Connessione",
          disconnect: "Disconnetti",
          tryAgain: "Riprova",
          qrcode: "CODICE QR",
          newQr: "Nuovo CODICE QR",
          closedImported: "Chiudi tutti i ticket importati",
          preparing: "Preparazione dei messaggi per l'importazione",
          importing: "Importazione dei Messaggi WhatsApp",
          processed: "Elaborato",
          in: "di",
          connecting: "Connessione"
        },
        typography: {
          processed: "Elaborato",
          in: "di",
          date: "Data del messaggio"
        },
        toolTips: {
          disconnected: {
            title: "Errore durante la connessione a WhatsApp",
            content: "Assicurati che il tuo telefono sia connesso a Internet e riprova, o richiedi un nuovo Codice QR"
          },
          qrcode: {
            title: "In attesa della lettura del Codice QR",
            content: "Clicca sul pulsante 'CODICE QR' e leggi il Codice QR con il tuo telefono per accedere"
          },
          connected: {
            title: "Connessione stabilita!"
          },
          timeout: {
            title: "La connessione con il telefono è stata persa",
            content: "Assicurati che il tuo telefono sia connesso a Internet e che WhatsApp sia aperto, o clicca sul pulsante 'Disconnetti' per ottenere un nuovo Codice QR"
          }
        },
        table: {
          name: "Nome",
          status: "Stato",
          lastUpdate: "Ultimo aggiornamento",
          "default": "Predefinito",
          actions: "Azioni",
          session: "Sessione",
          number: "Numero di WhatsApp"
        }
      },
      showTicketOpenModal: {
        title: {
          header: "Servizio Esistente"
        },
        form: {
          message: "Questo contatto è già in assistenza:",
          user: "Agente",
          queue: "Coda",
          messageWait: "Questo contatto sta già aspettando l'assistenza. Vai nella scheda In Attesa!"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Registrazioni"
        },
        options: {
          create: "Ticket creato.",
          chatBot: "ChatBot avviato.",
          queue: " - Coda definita.",
          open: " ha iniziato il servizio.",
          access: "ha accesso al ticket.",
          transfered: "ha trasferito il ticket.",
          receivedTransfer: "ha ricevuto il ticket trasferito.",
          pending: "ha restituito alla coda.",
          closed: "ha chiuso il ticket",
          reopen: "ha riaperto il ticket",
          redirect: "- reindirizzato"
        }
      },
      whatsappModal: {
        title: {
          add: "Aggiungi Connessione",
          edit: "Modifica Connessione"
        },
        tabs: {
          general: "Generale",
          messages: "Messaggi",
          assessments: "NPS",
          integrations: "Integrazioni",
          schedules: "Orari di servizio"
        },
        form: {
          importOldMessagesEnable: "Importa messaggi dal dispositivo",
          importOldMessages: "Data di inizio dell'importazione",
          importRecentMessages: "Data di fine dell'importazione",
          importOldMessagesGroups: "Importa messaggi di gruppo",
          closedTicketsPostImported: "Chiudi ticket dopo l'importazione",
          name: "Nome",
          queueRedirection: "Reindirizzamento di Coda",
          queueRedirectionDesc: "Seleziona una coda affinché i contatti senza coda vengano reindirizzati",
          "default": "Predefinito",
          group: "Consenti gruppi",
          timeSendQueue: "Tempo in minuti per reindirizzare alla coda",
          importAlert: "ATTENZIONE: Salvando, la tua connessione verrà chiusa, sarà necessario leggere nuovamente il Codice QR per importare i messaggi",
          groupAsTicket: "Tratta i gruppi come ticket",
          timeCreateNewTicket: "Crea nuovo ticket in x minuti",
          maxUseBotQueues: "Invia bot x volte",
          timeUseBotQueues: "Invia bot in x minuti",
          expiresTicket: "Chiudi chat aperti dopo x minuti",
          expiresTicketNPS: "Chiudi chat in attesa di valutazione dopo x minuti",
          maxUseBotQueuesNPS: "Numero massimo di volte che la valutazione verrà inviata",
          closeLastMessageOptions1: "Dell'agente/Cliente",
          closeLastMessageOptions2: "Dell'agente",
          outOfHoursMessage: "Messaggio fuori orario di servizio",
          greetingMessage: "Messaggio di benvenuto",
          complationMessage: "Messaggio di conclusione",
          lgpdLinkPrivacy: "Link alla politica sulla privacy",
          lgpdMessage: "Messaggio di benvenuto GDPR",
          lgpdDeletedMessages: "Oscura messaggio cancellato dal contatto",
          lgpdSendMessage: "Richiedi sempre la conferma del contatto",
          ratingMessage: "Messaggio di valutazione - La scala deve essere da 0 a 10",
          token: "Token per integrazione esterna",
          sendIdQueue: "Coda",
          inactiveMessage: "Messaggio di inattività",
          timeInactiveMessage: "Tempo in minuti per l'invio dell'avviso di inattività",
          whenExpiresTicket: "Chiudi chat aperti quando l'ultimo messaggio è",
          expiresInactiveMessage: "Messaggio di chiusura per inattività",
          prompt: "Prompt",
          collectiveVacationEnd: "Data di fine",
          collectiveVacationStart: "Data di inizio",
          collectiveVacationMessage: "Messaggio di vacanze collettive",
          queueIdImportMessages: "Coda per importare i messaggi"
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla"
        },
        menuItem: {
          enabled: "Abilitato",
          disabled: "Disabilitato",
          minutes: "minuti"
        },
        success: "Connessione salvata con successo.",
        errorSendQueue: "È stato informato un tempo per reindirizzare la coda, ma non è stata selezionata nessuna coda per il reindirizzamento. Entrambi i campi devono essere compilati",
        errorExpiresNPS: "È obbligatorio informare un tempo per la valutazione quando si utilizza NPS.",
        errorRatingMessage: "È obbligatorio informare un messaggio di valutazione quando si utilizza NPS."
      },
      qrCode: {
        message: "Leggi il QrCode per avviare la sessione"
      },
      contacts: {
        title: "Contatti",
        toasts: {
          deleted: "Contatto eliminato con successo!"
        },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Elimina ",
          importTitlte: "Importa contatti",
          exportContact: "Esporta contatti",
          deleteMessage: "Sei sicuro di voler eliminare questo contatto? Tutti i servizi associati andranno persi.",
          blockContact: "Sei sicuro di voler bloccare questo contatto?",
          unblockContact: "Sei sicuro di voler sbloccare questo contatto?",
          importMessage: "Vuoi importare tutti i contatti del telefono?",
          importChat: "Importa Conversazioni",
          wantImport: "Vuoi importare tutte le conversazioni del telefono?"
        },
        buttons: {
          import: "Importa Contatti",
          add: "Aggiungi Contatto",
          export: "Esporta Contatto"
        },
        table: {
          name: "Nome",
          whatsapp: "Connessione",
          email: "E-mail",
          actions: "Azioni",
          lastMessage: "Ultimo Messaggio"
        },
        menu: {
          importYourPhone: "Importa dal dispositivo predefinito",
          importToExcel: "Importa / Esporta da Excel"
        }
      },
      forwardMessage: {
        text: "Inoltrato"
      },
      forwardMessageModal: {
        title: "Inoltra messaggio",
        buttons: {
          ok: "Inoltra"
        },
        status: {
          sending: "Invio del messaggio {{id}}..."
        },
        errors: {
          noContactFound: "Nessun contatto trovato con il nome {{name}}"
        }
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voce",
          max_tokens: "Massimo di Token nella risposta",
          temperature: "Temperatura",
          apikey: "Chiave API",
          max_messages: "Massimo di messaggi nello Storico",
          voiceKey: "Chiave dell'API di Voce",
          voiceRegion: "Regione di Voce"
        },
        success: "Prompt salvato con successo!",
        title: {
          add: "Aggiungi Prompt",
          edit: "Modifica Prompt"
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla"
        }
      },
      prompts: {
        title: "Prompts",
        tabs: {
          prompts: "Prompts",
          knowledgeBase: "Base di Conoscenza",
          aiSettings: "Impostazioni IA"
        },
        table: {
          name: "Nome",
          queue: "Settore/Coda",
          max_tokens: "Massimo Token Risposta",
          actions: "Azioni"
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata!"
        },
        buttons: {
          add: "Aggiungi Prompt"
        },
        knowledgeBase: {
          buttons: {
            upload: "Carica file",
            addText: "Aggiungi testo"
          },
          table: {
            title: "Titolo",
            type: "Tipo",
            status: "Stato",
            size: "Dimensione",
            createdAt: "Creato",
            actions: "Azioni"
          },
          status: {
            indexed: "Indicizzato",
            stored: "Salvato",
            processing: "Elaborazione",
            failed: "Errore",
            pending: "In attesa"
          },
          empty: "Nessun documento per ora.",
          modalUpload: {
            title: "Carica documento",
            form: {
              title: "Titolo (opzionale)",
              description: "Descrizione (opzionale)"
            },
            buttons: {
              cancel: "Annulla",
              send: "Carica"
            }
          },
          modalText: {
            title: "Aggiungi testo",
            form: {
              title: "Titolo",
              description: "Descrizione (opzionale)",
              content: "Contenuto"
            },
            buttons: {
              cancel: "Annulla",
              save: "Salva"
            }
          },
          confirm: {
            deleteTitle: "Elimina",
            deleteMessage: "Sei sicuro? Questa azione non può essere annullata!"
          },
          toasts: {
            uploaded: "Documento caricato.",
            created: "Documento creato.",
            deleted: "Documento eliminato.",
            fileRequired: "Il file è obbligatorio.",
            titleRequired: "Il titolo è obbligatorio.",
            contentRequired: "Il contenuto è obbligatorio."
          }
        },
        aiSettings: {
          form: {
            isEnabled: "IA abilitata",
            openaiModel: "Modello",
            openaiTemperature: "Temperatura",
            openaiMaxTokens: "Token max",
            useRag: "Usa base di conoscenza (RAG)",
            ragTopK: "RAG Top K",
            ragMinScore: "Punteggio minimo RAG",
            maxHistory: "Storico massimo",
            personality: "Personalità",
            instructions: "Istruzioni",
            language: "Lingua (codice ISO)"
          },
          usage: {
            limit: "Limite token",
            used: "Usati",
            remaining: "Rimanenti",
            addTokens: "Aggiungi token"
          },
          buttons: {
            save: "Salva",
            addTokens: "Aggiungi"
          },
          toasts: {
            saved: "Impostazioni IA salvate.",
            tokensInvalid: "I token devono essere maggiori di 0.",
            tokensAdded: "Token aggiunti."
          }
        }
      },
      contactModal: {
        title: {
          add: "Aggiungi contatto",
          edit: "Modifica contatto"
        },
        form: {
          mainInfo: "Dati del contatto",
          extraInfo: "Informazioni aggiuntive",
          name: "Nome",
          number: "Numero di WhatsApp",
          email: "E-mail",
          extraName: "Nome del campo",
          extraValue: "Valore",
          chatBotContact: "Disabilita chatbot",
          termsLGDP: "Termini GDPR accettati il:",
          whatsapp: "Connessione Origine: "
        },
        buttons: {
          addExtraInfo: "Aggiungi informazione",
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla"
        },
        success: "Contatto salvato con successo."
      },
      flowbuilder: {
        title: "Flowbuilder",
        subMenus: {
          campaign: "Flusso di Campagna",
          conversation: "Flusso di Conversazione"
        }
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flusso predefinito"
      },
      queueModal: {
        title: {
          queueData: "Dati della coda",
          text: "Orari di servizio",
          add: "Aggiungi coda",
          edit: "Modifica coda",
          confirmationDelete: "Sei sicuro? Tutte le opzioni di integrazioni verranno eliminate."
        },
        form: {
          name: "Nome",
          color: "Colore",
           orderQueue: "Ordine della coda (Bot)",
           rotate: "Rotazione",
           timeRotate: "Tempo di Rotazione",
           minutes: "minuti",
           none: "Nessuna",
           greetingMessage: "Messaggio di benvenuto",
           complationMessage: "Messaggio di conclusione",
           outOfHoursMessage: "Messaggio fuori orario di servizio",
           token: "Token",
           integrationId: "Integrazione",
          fileListId: "Lista di file",
          closeTicket: "Chiudi ticket",
          queueType: "Tipo di menu",
          message: "Messaggio di ritorno",
           queue: "Coda per trasferimento",
           integration: "Integrazione",
           file: "File",
           selectFile: "Seleziona un file"
         },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla"
        },
        bot: {
          title: "Opzioni",
          toolTipTitle: "Aggiungi opzioni per costruire un chatbot",
          toolTip: "Se c'è solo un'opzione, verrà scelta automaticamente, facendo sì che il bot risponda con il messaggio dell'opzione e continui",
          selectOption: "Seleziona un'opzione",
          text: "Testo",
          attendent: "Agente",
          queue: "Coda",
          integration: "Integrazione",
          file: "File",
          toolTipMessageTitle: "Il messaggio è obbligatorio per continuare al livello successivo",
          toolTipMessageContent: "Il messaggio è obbligatorio per continuare al livello successivo",
          selectUser: "Seleziona un Utente",
          selectQueue: "Seleziona una Coda",
          selectIntegration: "Seleziona un'Integrazione",
          addOptions: "Aggiungi opzioni"
        },
        serviceHours: {
          dayWeek: "Giorno della settimana",
          startTimeA: "Ora di Inizio - Turno A",
          endTimeA: "Ora di Fine - Turno A",
          startTimeB: "Ora di Inizio - Turno B",
          endTimeB: "Ora di Fine - Turno B",
          monday: "Lunedì",
          tuesday: "Martedì",
          wednesday: "Mercoledì",
          thursday: "Giovedì",
          friday: "Venerdì",
          saturday: "Sabato",
          sunday: "Domenica"
        }
      },
      queueIntegrationModal: {
        title: {
          add: "Aggiungi progetto",
          edit: "Modifica progetto"
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome del Progetto",
          language: "Lingua",
          jsonContent: "Contenuto Json",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo in minuti per far scadere una conversazione",
          typebotKeywordFinish: "Parola per finalizzare il ticket",
          typebotKeywordRestart: "Parola per riavviare il flusso",
          typebotRestartMessage: "Messaggio al riavvio della conversazione",
          typebotUnknownMessage: "Messaggio di opzione non valida",
          typebotDelayMessage: "Intervallo (ms) tra messaggi"
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
          test: "Testa Bot"
        },
        messages: {
          testSuccess: "Integrazione testata con successo!",
          addSuccess: "Integrazione aggiunta con successo.",
          editSuccess: "Integrazione modificata con successo."
        }
      },
      userModal: {
        warning: "Per effettuare l'importazione dei messaggi è necessario leggere nuovamente il qrCode !!!",
        title: {
          add: "Aggiungi utente",
          edit: "Modifica utente",
          updateImage: "Aggiorna immagine",
          removeImage: "Rimuovi immagine"
        },
        form: {
          name: "Nome",
          none: "Nessuno",
          email: "E-mail",
          password: "Password",
          passwordHint: "Lascia vuoto per mantenere la password attuale",
          confirmPassword: "Conferma password",
          farewellMessage: "Messaggio di commiato",
          profile: "Profilo",
          startWork: "Inizio lavoro",
          endWork: "Fine lavoro",
          whatsapp: "Connessione Predefinita",
          allTicketEnable: "Abilitato",
          allTicketDisable: "Disabilitato",
          allTicket: "Visualizza chiamate senza coda",
          allowGroup: "Consenti Gruppi",
          defaultMenuOpen: "Aperto",
          defaultMenuClosed: "Chiuso",
          defaultMenu: "Menu predefinito",
          defaultTheme: "Tema Predefinito",
          defaultThemeDark: "Scuro",
          defaultThemeLight: "Chiaro",
          allHistoric: "Vedi conversazioni di altre code",
          allHistoricEnabled: "Abilitato",
          allHistoricDisabled: "Disabilitato",
          allUserChat: "Vedi conversazioni di altri utenti",
          userClosePendingTicket: "Consenti di chiudere ticket in attesa",
          showDashboard: "Vedi Dashboard",
          allowRealTime: "Vedi Pannello di Servizi",
          allowConnections: "Consenti azioni nelle connessioni"
        },
        tabs: {
          general: "Generale",
          permissions: "Permessi"
        },
        permissions: {
          noPermission: "Non hai i permessi per modificare questa sezione."
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
          addImage: "Aggiungi Immagine",
          editImage: "Modifica Immagine",
          resetPassword: "Reimposta password",
          togglePassword: "Mostra/nascondi password"
        },
        errors: {
          passwordRequired: "La password è obbligatoria."
        },
        toasts: {
          passwordGenerated: "Password generata.",
          passwordGeneratedCopied: "Password generata e copiata negli appunti."
        },
        success: "Utente salvato con successo."
      },
      companyModal: {
        title: {
          add: "Aggiungi azienda",
          edit: "Modifica azienda"
        },
        form: {
          name: "Nome",
          email: "E-mail",
          passwordDefault: "Password",
          numberAttendants: "Utenti",
          numberConections: "Connessioni"
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla"
        },
        success: "Azienda salvata con successo."
      },
      scheduleModal: {
        title: {
          add: "Nuovo invio massivo",
          edit: "Modifica invio massivo"
        },
        statusTitle: {
          sendError: "Errore di invio",
          messageWithStatus: "Messaggio {{status}}"
        },
        form: {
          body: "Messaggio",
          contact: "Contatto",
          sendAt: "Data di invio",
          sentAt: "Data di Invio",
          assinar: "Invia Firma"
        },
        labels: {
          attachedFile: "File allegato: {{name}}"
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
          attachFile: "Allega file",
          addSchedule: "Aggiungi invio massivo"
        },
        success: "Invio massivo salvato con successo."
      },
      recurrence: {
        title: "Ricorrenza",
        description:
          "Puoi inviare il messaggio in modo ricorrente e scegliere l'intervallo. Se è un messaggio singolo, non modificare nulla in questa sezione.",
        interval: {
          label: "Intervallo",
          valueLabel: "Valore dell'intervallo",
          options: {
            days: "Giorni",
            weeks: "Settimane",
            months: "Mesi",
            minutes: "Minuti"
          }
        },
        sendCount: {
          label: "Numero di invii"
        },
        businessDaysPolicy: {
          label: "Giorni non lavorativi",
          options: {
            normal: "Invia normalmente nei giorni non lavorativi",
            before: "Invia un giorno lavorativo prima",
            after: "Invia un giorno lavorativo dopo"
          }
        },
        showUser: "Mostra utente"
      },
      tagModal: {
        title: {
          add: "Nuova Etichetta",
          edit: "Modifica Etichetta",
          addKanban: "Nuova Colonna",
          editKanban: "Modifica Colonna"
        },
        form: {
          name: "Nome",
          color: "Colore",
          timeLane: "Tempo in ore per reindirizzare alla colonna",
          nextLaneId: "Colonna",
          greetingMessageLane: "Messaggio di benvenuto della colonna",
          rollbackLaneId: "Torna alla Colonna dopo aver ripreso il servizio"
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla"
        },
        success: "Etichetta salvata con successo.",
        successKanban: "Colonna salvata con successo."
      },
      fileModal: {
        title: {
          add: "Aggiungi lista di file",
          edit: "Modifica lista di file"
        },
        buttons: {
          okAdd: "Salva",
          okEdit: "Modifica",
          cancel: "Annulla",
          fileOptions: "Aggiungi file"
        },
        form: {
          name: "Nome della lista di file",
          message: "Dettagli della lista",
          fileOptions: "Lista di file",
          extraName: "Messaggio da inviare con il file",
          extraValue: "Valore dell'opzione"
        },
        success: "Lista di file salvata con successo!"
      },
      chat: {
        noTicketMessage: "Seleziona un ticket per iniziare a conversare.",
        configureApis: "Configura API"
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ TRASCINA E RILASCIA I FILE NEL CAMPO QUI SOTTO ⬇️",
          titleFileList: "Lista di file"
        }
      },
      chatInternal: {
        new: "Nuovo",
        tabs: {
          chats: "Chat",
          messages: "Messaggi"
        },
        aria: {
          tabs: "Schede della chat interna"
        },
        modal: {
          conversation: "Conversazione",
          title: "Titolo",
          filterUsers: "Filtra per Utenti",
          cancel: "Chiudi",
          save: "Salva"
        },
        modalDelete: {
          title: "Elimina Conversazione",
          message: "Questa azione non può essere annullata, confermare?"
        }
      },
      ticketsAdvanced: {
        tabs: {
          ticket: "Ticket",
          services: "Servizi"
        }
      },
      momentsUser: {
        pending: "In sospeso",
        labels: {
          servicesCount: "Servizi: {{count}}"
        }
      },
      ticketsManager: {
        questionCloseTicket: "VUOI CHIUDERE TUTTI I TICKET?",
        yes: "SÌ",
        not: "NO",
        buttons: {
          newTicket: "Nuovo",
          resolveAll: "Risolvi Tutti",
          close: "Chiudi",
          new: "Nuovo"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Code"
      },
      tickets: {
        inbox: {
          closedAllTickets: "Chiudere tutti i ticket?",
          closedAll: "Chiudi Tutti",
          newTicket: "Nuovo Ticket",
          yes: "SÌ",
          no: "NO",
          open: "Aperti",
          sortAscending: "Ascendente",
          sortDescending: "Discendente",
          resolverd: "Risolti"
        },
        toasts: {
          deleted: "Il servizio in cui eri è stato eliminato."
        },
        notification: {
          message: "Messaggio da"
        },
        tabs: {
          open: {
            title: "Aperti"
          },
          closed: {
            title: "Risolti"
          },
          search: {
            title: "Ricerca"
          }
        },
        search: {
          placeholder: "Cerca servizio e messaggi",
          filterConections: "Filtra per Connessione",
          filterConectionsOptions: {
            open: "Aperto",
            closed: "Chiuso",
            pending: "In Attesa"
          },
          filterUsers: "Filtra per Utenti",
          filterContacts: "Filtra per Contatti",
          ticketsPerPage: "Ticket per pagina"
        },
        buttons: {
          showAll: "Tutti",
          returnQueue: "Restituisci alla Coda",
          scredule: "Programmazione",
          deleteTicket: "Elimina Ticket"
        },
        closedTicket: {
          closedMessage: "Chiudi Ticket Con Messaggio di Commiato",
          closedNotMessage: "Chiudi Ticket Senza Messaggio di Commiato"
        },
        simulateIncoming: {
          channelFallback: "canale",
          body: "Messaggio di test ({{channel}})",
          menuLabel: "Simula messaggio in arrivo",
          toasts: {
            success: "Messaggio in arrivo simulato."
          }
        }
      },
      transferTicketModal: {
        title: "Trasferisci Ticket",
        fieldLabel: "Digita per cercare utenti",
        fieldQueueLabel: "Trasferisci alla coda",
        fieldQueuePlaceholder: "Seleziona una coda",
        fieldWhatsapp: "Seleziona un WhatsApp",
        noOptions: "Nessun utente trovato con questo nome",
        msgTransfer: "Osservazioni - messaggio interno, non va al cliente",
        buttons: {
          ok: "Trasferisci",
          cancel: "Annulla"
        }
      },
      ticketsList: {
        called: "Chiamato",
        today: "Oggi",
        missedCall: "Chiamata vocale/video persa alle",
        pendingHeader: "In Attesa",
        assignedHeader: "In Assistenza",
        groupingHeader: "Gruppi",
        noTicketsTitle: "Niente qui!",
        noTicketsMessage: "Nessun servizio trovato con questo stato o termine cercato",
        noQueue: "Senza Coda",
        buttons: {
          accept: "Accetta",
          cancel: "Annulla",
          start: "Inizia",
          closed: "Chiudi",
          reopen: "Riapri",
          transfer: "Trasferisci",
          ignore: "Ignora",
          exportAsPDF: "Esporta in PDF",
          kanbanActions: "Opzioni di Kanban"
        },
        acceptModal: {
          title: "Accetta Chat",
          queue: "Seleziona settore"
        }
      },
      newTicketModal: {
        title: "Crea Ticket",
        fieldLabel: "Digita per cercare il contatto",
        add: "Aggiungi",
        buttons: {
          ok: "Salva",
          cancel: "Annulla"
        }
      },
      SendContactModal: {
        title: "Invia contatto",
        fieldLabel: "Digita per cercare il contatto",
        add: "Aggiungi",
        buttons: {
          ok: "Invia",
          cancel: "Annulla"
        }
      },
      mainDrawer: {
        listItems: {
          dashboard: "Pannello di Controllo",
          connections: "Connessioni",
          chatsTempoReal: "Pannello",
          tickets: "Servizi",
          quickMessages: "Risposte rapide",
          contacts: "Contatti",
          queues: "Aree & Chatbot",
          flowbuilder: "Flowbuilder",
          tags: "Etichette",
          administration: "Amministrazione",
          companies: "Aziende",
          users: "Utenti",
          settings: "Impostazioni",
          files: "Lista di file",
          helps: "Aiuto",
          messagesAPI: "Connetti API",
          schedules: "Invii massivi",
          campaigns: "Campagne",
          annoucements: "Informativi",
          chats: "Chat Interno",
          financeiro: "Finanziario",
          queueIntegration: "Integrazioni",
          version: "Versione",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gestisci connessioni",
          reports: "Rapporti",
          management: "Gestione",
          subscription: "Abbonamento",
          salesDashboard: "Dashboard vendite",
          leads: "Lead",
          registerClient: "Registra cliente",
          commission: "Commissioni",
          teamDashboard: "Dashboard team",
          analytics: "Analitiche",
          clientDashboard: "Il mio dashboard",
          inbox: "Posta in arrivo",
          whatsappApi: "WhatsApp API",
          whatsappQr: "WhatsApp QR",
          facebookInstagram: "Facebook / Instagram",
          ai: "IA"
        },
        sections: {
          main: "Principale",
          sales: "Vendite",
          service: "Assistenza",
          marketing: "Marketing",
          aiAutomation: "IA & Automazione",
          tools: "Strumenti",
          team: "Team",
          reports: "Report",
          channels: "Canali"
        },
        appBar: {
          user: {
            profile: "Profilo",
            logout: "Esci",
            message: "Ciao",
            messageEnd: "benvenuto a",
            active: "Attivo fino al",
            goodMorning: "Ciao,",
            myName: "mi chiamo",
            continuity: "e darò seguito al tuo servizio.",
            virtualAssistant: "datxale",
            token: "Token non valido, contatta l'amministratore della piattaforma."
          },
          message: {
            location: "Posizione",
            contact: "Contatto"
          },
          notRegister: "Nessuna registrazione",
          refresh: "Aggiorna"
        }
      },
      languages: {
        undefined: "Lingua",
        es: "Spagnolo",
        en: "English",
        "pt-BR": "Portoghese",
        fr: "Francese",
        it: "Italiano"
      },
      messagesAPI: {
        title: "Connetti API",
        textMessage: {
          number: "Numero",
          body: "Messaggio",
          token: "Token registrato",
          userId: "ID dell'utente/agente",
          queueId: "ID della Coda"
        },
        mediaMessage: {
          number: "Numero",
          body: "Nome del file",
          media: "File",
          token: "Token registrato"
        },
        API: {
          title: "Documentazione per l'invio di messaggi",
          methods: {
            title: "Metodi di Invio",
            messagesText: "Messaggi di Testo",
            messagesMidia: "Messaggi Media"
          },
          instructions: {
            title: "Istruzioni",
            comments: "Osservazioni Importanti",
            comments1: "Prima di inviare messaggi, è necessaria la registrazione del token collegato alla connessione che invierà i messaggi. <br />Per effettuare la registrazione, accedi al menu 'Connessioni', clicca sul pulsante modifica della connessione e inserisci il token nel campo appropriato.",
            comments2: "Il numero per l'invio non deve avere maschere o caratteri speciali e deve essere composto da:",
            codeCountry: "Codice del Paese",
            code: "Prefisso",
            number: "Numero"
          },
          text: {
            title: "1. Messaggi di Testo",
            instructions: "Di seguito la lista delle informazioni necessarie per l'invio di messaggi di testo:"
          },
          media: {
            title: "2. Messaggi Media",
            instructions: "Di seguito la lista delle informazioni necessarie per l'invio di messaggi media:"
          }
        }
      },
      notifications: {
        noTickets: "Nessuna notifica."
      },
      quickMessages: {
        title: "Risposte Rapide",
        searchPlaceholder: "Cerca...",
        noAttachment: "Senza allegato",
        confirmationModal: {
          deleteTitle: "Eliminazione",
          deleteMessage: "Questa azione è irreversibile! Vuoi continuare?"
        },
        buttons: {
          add: "Aggiungi",
          attach: "Allega File",
          cancel: "Annulla",
          edit: "Modifica"
        },
        toasts: {
          success: "Scorciatoia aggiunta con successo!",
          deleted: "Scorciatoia rimossa con successo!"
        },
        dialog: {
          title: "Messaggio Rapido",
          shortcode: "Scorciatoia",
          message: "Risposta",
          save: "Salva",
          cancel: "Annulla",
          geral: "Consenti modifica",
          add: "Aggiungi",
          edit: "Modifica",
          visao: "Consenti visualizzazione"
        },
        table: {
          shortcode: "Scorciatoia",
          message: "Messaggio",
          actions: "Azioni",
          mediaName: "Nome del File",
          status: "Stato"
        }
      },
      contactLists: {
        title: "Liste di Contatti",
        table: {
          name: "Nome",
          contacts: "Contatti",
          actions: "Azioni"
        },
        buttons: {
          add: "Nuova Lista"
        },
        dialog: {
          name: "Nome",
          company: "Azienda",
          okEdit: "Modifica",
          okAdd: "Aggiungi",
          add: "Aggiungi",
          edit: "Modifica",
          cancel: "Annulla"
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata."
        },
        toasts: {
          deleted: "Registrazione eliminata"
        }
      },
      contactListItems: {
        title: "Contatti",
        searchPlaceholder: "Ricerca",
        buttons: {
          add: "Nuovo",
          lists: "Liste",
          import: "Importa"
        },
        dialog: {
          name: "Nome",
          number: "Numero",
          whatsapp: "WhatsApp",
          email: "E-mail",
          okEdit: "Modifica",
          okAdd: "Aggiungi",
          add: "Aggiungi",
          edit: "Modifica",
          cancel: "Annulla"
        },
        table: {
          name: "Nome",
          number: "Numero",
          whatsapp: "WhatsApp",
          email: "E-mail",
          actions: "Azioni"
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata.",
          importMessage: "Vuoi importare i contatti da questo foglio? ",
          importTitlte: "Importa"
        },
        toasts: {
          deleted: "Registrazione eliminata"
        }
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Ricerca",
        subMenus: {
          list: "Pannello",
          tags: "Corsie"
        }
      },
      campaigns: {
        title: "Campagne",
        searchPlaceholder: "Ricerca",
        subMenus: {
          list: "Elenco",
          listContacts: "Lista di contatti",
          settings: "Impostazioni"
        },
        settings: {
          randomInterval: "Intervallo Casuale di Attivazione",
          noBreak: "Senza Intervallo",
          intervalGapAfter: "Intervallo maggiore dopo",
          undefined: "Non definito",
          messages: "messaggi",
          laggerTriggerRange: "Intervallo di attivazione maggiore",
          addVar: "Aggiungi variabile",
          save: "Salva",
          close: "Chiudi",
          add: "Aggiungi",
          shortcut: "Scorciatoia",
          content: "Contenuto"
        },
        buttons: {
          add: "Nuova Campagna",
          contactLists: "Liste di Contatti"
        },
        table: {
          name: "Nome",
          whatsapp: "Connessione",
          contactList: "Lista di Contatti",
          option: "Nessuna",
          disabled: "Disabilitata",
          enabled: "Abilitata",
          status: "Stato",
          scheduledAt: "Programmazione",
          completedAt: "Completata",
          confirmation: "Conferma",
          actions: "Azioni"
        },
        actions: {
          start: "Avvia",
          stop: "Ferma",
          restart: "Riavvia"
        },
        dialog: {
          new: "Nuova Campagna",
          update: "Modifica Campagna",
          readonly: "Solo Visualizzazione",
          help: "Usa variabili come {nome}, {numero}, {email} o definisci variabili personalizzate.",
          validation: {
            required: "Campo obbligatorio",
            nameMin: "Minimo 2 caratteri",
            nameMax: "Massimo 50 caratteri"
          },
          form: {
            name: "Nome",
            message1: "Messaggio 1",
            message2: "Messaggio 2",
            message3: "Messaggio 3",
            message4: "Messaggio 4",
            message5: "Messaggio 5",
            confirmationMessage1: "Messaggio di Conferma 1",
            confirmationMessage2: "Messaggio di Conferma 2",
            confirmationMessage3: "Messaggio di Conferma 3",
            confirmationMessage4: "Messaggio di Conferma 4",
            confirmationMessage5: "Messaggio di Conferma 5",
            messagePlaceholder: "Contenuto del messaggio",
            whatsapp: "Connessione",
            status: "Stato",
            scheduledAt: "Programmazione",
            confirmation: "Conferma",
            contactList: "Lista di Contatti",
            tagList: "Etichette",
            statusTicket: "Stato del Ticket",
            openTicketStatus: "Aperto",
            pendingTicketStatus: "In Attesa",
            closedTicketStatus: "Chiuso",
            enabledOpenTicket: "Abilitato",
            disabledOpenTicket: "Disabilitato",
            openTicket: "Apri ticket",
            sendType: "Tipo di invio",
            sendTypeTemplate: "Template (Meta)",
            sendTypeText: "Testo",
            template: "Template",
            templatePlaceholder: "Seleziona template",
            templateLoading: "Caricamento template...",
            templateEmpty: "Nessun template approvato",
            templateSelectWhatsapp: "Seleziona prima una connessione"
          },
          buttons: {
            add: "Aggiungi",
            edit: "Aggiorna",
            okadd: "Ok",
            cancel: "Annulla Attivazioni",
            restart: "Riavvia Attivazioni",
            close: "Chiudi",
            attach: "Allega File"
          }
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata."
        },
        toasts: {
          success: "Operazione eseguita con successo",
          start: "Campagna avviata",
          cancel: "Campagna annullata",
          restart: "Campagna riavviata",
          deleted: "Registrazione eliminata"
        }
      },
      campaignReport: {
        title: "Rapporto di",
        inactive: "Inattiva",
        scheduled: "Programmata",
        process: "In Corso",
        cancelled: "Annullata",
        finished: "Completata",
        campaign: "Campagna",
        validContacts: "Contatti Validi",
        confirmationsRequested: "Conferme Richieste",
        confirmations: "Conferme",
        deliver: "Consegnati",
        connection: "Connessione",
        contactLists: "Lista di Contatti",
        schedule: "Programmazione",
        conclusion: "Conclusione",
        noPermission: "Questa azienda non ha l'autorizzazione per accedere a questa pagina. Reindirizzamento in corso.",
        statusLine: "Stato: {{status}} {{current}} di {{total}}"
      },
      announcements: {
        title: "Informativi",
        searchPlaceholder: "Ricerca",
        active: "Attivo",
        inactive: "Inattivo",
        buttons: {
          add: "Nuovo Informativo",
          contactLists: "Liste di Informativi"
        },
        table: {
          priority: "Priorità",
          title: "Titolo",
          text: "Testo",
          mediaName: "File",
          status: "Stato",
          actions: "Azioni"
        },
        dialog: {
          edit: "Modifica di Informativo",
          add: "Nuovo Informativo",
          update: "Modifica Informativo",
          readonly: "Solo Visualizzazione",
          form: {
            priority: "Priorità",
            title: "Titolo",
            text: "Testo",
            mediaPath: "File",
            status: "Stato",
            high: "Alta",
            medium: "Media",
            low: "Bassa",
            active: "Attivo",
            inactive: "Inattivo"
          },
          buttons: {
            add: "Aggiungi",
            edit: "Aggiorna",
            okadd: "Ok",
            cancel: "Annulla",
            close: "Chiudi",
            attach: "Allega File"
          }
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata."
        },
        toasts: {
          success: "Operazione eseguita con successo",
          deleted: "Registrazione eliminata"
        }
      },
      campaignsConfig: {
        title: "Impostazioni di Campagne"
      },
      queues: {
        title: "Aree & Chatbot",
        table: {
          name: "Nome",
          color: "Colore",
          greeting: "Messaggio di benvenuto",
          orderQueue: "Ordine dell'area (bot)",
          actions: "Azioni",
          ID: "ID"
        },
        buttons: {
          add: "Aggiungi area"
        },
        toasts: {
          success: "Area salvata con successo",
          deleted: "Area eliminata con successo"
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata! I servizi di questa area continueranno ad esistere, ma non avranno più un'area assegnata."
        }
      },
      queue: {
        queueData: "Dati"
      },
      queueSelect: {
        inputLabel: "Aree",
        inputLabelRO: "Aree di sola lettura",
        withoutQueue: "Senza area",
        undefined: "Area non trovata",
      },
      reports: {
        title: "Rapporti di Servizi",
        table: {
          id: "Ticket",
          user: "Utente",
          dateOpen: "Data Apertura",
          dateClose: "Data Chiusura",
          NPS: "NPS",
          status: "Stato",
          whatsapp: "Connessione",
          queue: "Area",
          actions: "Azioni",
          lastMessage: "Ult. Messaggio",
          contact: "Cliente",
          supportTime: "Tempo di Servizio"
        },
        buttons: {
          filter: "Applica Filtro",
          onlyRated: "Solo Valutati"
        },
        searchPlaceholder: "Cerca...",
        tooltips: {
          openTicket: "Accedi al ticket"
        },
        export: {
          timeOpen: "Ora Apertura",
          timeClose: "Ora Chiusura",
          sheetName: "RapportiServizi",
          fileName: "rapporti-servizi.xlsx"
        }
      },
      queueIntegration: {
        title: "Integrazioni",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome del Progetto",
          language: "Lingua",
          lastUpdate: "Ultimo aggiornamento",
          actions: "Azioni"
        },
        buttons: {
          add: "Aggiungi Progetto"
        },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata! e verrà rimossa dalle code e connessioni collegate"
        }
      },
      users: {
        title: "Utenti",
        table: {
          status: "Stato",
          name: "Nome",
          email: "E-mail",
          profile: "Profilo",
          startWork: "Inizio lavoro",
          endWork: "Fine lavoro",
          actions: "Azioni",
          ID: "ID"
        },
        buttons: {
          add: "Aggiungi utente"
        },
        toasts: {
          deleted: "Utente eliminato con successo."
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Tutti i dati dell'utente verranno persi. I servizi aperti di questo utente verranno spostati alla coda."
        }
      },
      compaies: {
        title: "Aziende",
        table: {
          ID: "ID",
          status: "Attivo",
          name: "Nome",
          email: "E-mail",
          password: "Password",
          phone: "Telefono",
          plan: "Piano",
          active: "Attivo",
          numberAttendants: "Agenti",
          numberConections: "Connessioni",
          value: "Valore",
          namePlan: "Nome Piano",
          numberQueues: "Code",
          useCampaigns: "Campagne",
          useExternalApi: "API REST",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Chat Interno",
          useSchedules: "Invii massivi",
          createdAt: "Creato Il",
          dueDate: "Scadenza",
          lastLogin: "Ult. Accesso",
          actions: "Azioni",
          money: "€",
          yes: "Sì",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Ricorrenza",
          monthly: "Mensile",
          bimonthly: "Bimestrale",
          quarterly: "Trimestrale",
          semester: "Semestrale",
          yearly: "Annuale",
          clear: "Cancella",
          delete: "Elimina",
          user: "Utente",
          save: "Salva"
        },
        buttons: {
          add: "Aggiungi azienda"
        },
        toasts: {
          deleted: "Azienda eliminata con successo."
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Tutti i dati dell'azienda verranno persi. I ticket aperti di questo utente verranno spostati alla coda."
        }
      },
      plans: {
        form: {
          name: "Nome",
          users: "Utenti",
          connections: "Connessioni",
          campaigns: "Campagne",
          schedules: "Invii massivi",
          aiTokensIncluded: "Token IA inclusi",
          enabled: "Abilitate",
          disabled: "Disabilitate",
          clear: "Annulla",
          delete: "Elimina",
          save: "Salva",
          yes: "Sì",
          no: "No",
          money: "€",
          public: "Pubblico"
        }
      },
      helps: {
        title: "Centro Aiuto",
        settings: {
          codeVideo: "Codice del Video",
          description: "Descrizione",
          clear: "Cancella",
          delete: "Elimina",
          save: "Salva"
        }
      },
      schedules: {
        title: "Invii massivi",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questo invio massivo?",
          deleteMessage: "Questa azione non può essere annullata."
        },
        table: {
          contact: "Contatto",
          body: "Messaggio",
          sendAt: "Data di invio",
          sentAt: "Data di Invio",
          status: "Stato",
          actions: "Azioni"
        },
        buttons: {
          add: "Nuovo invio massivo"
        },
        toasts: {
          deleted: "Invio massivo eliminato con successo."
        }
      },
      tags: {
        title: "Etichette",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questa Etichetta?",
          deleteMessage: "Questa azione non può essere annullata."
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Colore",
          tickets: "Registrazioni Etichette",
          contacts: "Contatti",
          actions: "Azioni"
        },
        buttons: {
          add: "Nuova Etichetta"
        },
        toasts: {
          deleted: "Etichetta eliminata con successo."
        }
      },
      tagsKanban: {
        title: "Corsie",
        laneDefault: "In aperto",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questa Corsia?",
          deleteMessage: "Questa azione non può essere annullata."
        },
        table: {
          name: "Nome",
          color: "Colore",
          tickets: "Ticket",
          actions: "Azioni"
        },
        buttons: {
          add: "Nuova Corsia"
        },
        toasts: {
          deleted: "Corsia eliminata con successo."
        }
      },
      files: {
        title: "Lista di file",
        table: {
          name: "Nome",
          contacts: "Contatti",
          actions: "Azione"
        },
        toasts: {
          deleted: "Lista eliminata con successo!",
          deletedAll: "Tutte le liste sono state eliminate con successo!"
        },
        buttons: {
          add: "Aggiungi",
          deleteAll: "Elimina Tutti"
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteAllTitle: "Elimina Tutti",
          deleteMessage: "Sei sicuro di voler eliminare questa lista?",
          deleteAllMessage: "Sei sicuro di voler eliminare tutte le liste?"
        }
      },
      settings: {
        success: "Impostazioni salvate con successo.",
        title: "Impostazioni",
        tabs: {
          options: "Opzioni",
          plans: "Piani",
          helps: "Aiuto"
        },
        settings: {
          userCreation: {
            name: "Creazione utente",
            options: {
              enabled: "Attivato",
              disabled: "Disattivato"
            }
          },
          tabs: {
            options: "Opzioni",
            schedules: "Orari",
            plans: "Piani",
            help: "Aiuto"
          },
          options: {
            disabled: "Disabilitato",
            enabled: "Abilitato",
            updating: "Aggiornamento...",
            creationCompanyUser: "Creazione Azienda/Utente",
            evaluations: "Valutazioni",
            officeScheduling: "Programmazione di Servizio",
            queueManagement: "Gestione per Coda",
            companyManagement: "Gestione per Azienda",
            connectionManagement: "Gestione per Connessione",
            sendGreetingAccepted: "Invia messaggio di benvenuto all'accettazione del ticket",
            sendMsgTransfTicket: "Invia messaggio di trasferimento settore/agente",
            checkMsgIsGroup: "Ignora Messaggi di Gruppi",
            chatBotType: "Tipo di Bot",
            userRandom: "Scegli agente casuale",
            buttons: "Pulsanti",
            acceptCallWhatsapp: "Informare che non accetta chiamate su WhatsApp?",
            sendSignMessage: "Consenti all'agente di scegliere di INVIARE la Firma",
            sendGreetingMessageOneQueues: "Invia messaggio di benvenuto quando c'è solo una coda",
            sendQueuePosition: "Invia messaggio con la posizione nella coda",
            sendFarewellWaitingTicket: "Invia messaggio di commiato in attesa",
            acceptAudioMessageContact: "Accetta di ricevere audio da tutti i contatti?",
            enableLGPD: "Abilita trattamento GDPR",
            requiredTag: "Etichetta obbligatoria per chiudere il ticket",
            closeTicketOnTransfer: "Chiudi ticket al trasferimento ad altra coda",
            DirectTicketsToWallets: "Sposta automaticamente cliente al portafoglio",
            showNotificationPending: "Mostra notifica per ticket in attesa"
          },
          customMessages: {
            sendQueuePositionMessage: "Messaggio di posizione nella coda",
            AcceptCallWhatsappMessage: "Messaggio per informare che non accetta chiamate",
            greetingAcceptedMessage: "Messaggio di Benvenuto all'accettazione del ticket",
            transferMessage: `Messaggio di trasferimento - \${queue.name} = coda di destinazione`
          },
          LGPD: {
            title: "GDPR",
            welcome: "Messaggio di benvenuto (GDPR)",
            linkLGPD: "Link della politica sulla privacy",
            obfuscateMessageDelete: "Oscura messaggio cancellato",
            alwaysConsent: "Richiedi sempre il consenso",
            obfuscatePhoneUser: "Oscura numero di telefono per gli utenti",
            enabled: "Abilitato",
            disabled: "Disabilitato"
          }
        }
      },
      messagesList: {
        header: {
          assignedTo: "Assegnato a:",
          dialogRatingTitle: "Vuoi lasciare una valutazione del servizio per il cliente?",
          dialogClosingTitle: "Finalizzazione del servizio con il cliente!",
          dialogRatingCancel: "Risolvi CON Messaggio di Commiato",
          dialogRatingSuccess: "Risolvi e Invia Valutazione",
          dialogRatingWithoutFarewellMsg: "Risolvi SENZA Messaggio di Commiato",
          ratingTitle: "Scegli un menu di valutazione",
          notMessage: "Nessun messaggio selezionato",
          amount: "Valore di prospezione",
          buttons: {
            return: "Torna",
            resolve: "Risolvi",
            reopen: "Riapri",
            accept: "Accetta",
            rating: "Invia Valutazione",
            enableIntegration: "Abilita integrazione",
            disableIntegration: "Disabilita integrazione",
            logTicket: "Log del Ticket",
            requiredTag: "Devi assegnare un'etichetta prima di chiudere il ticket."
          }
        },
        forwarded: "Inoltrato",
        deletedText: "🚫 Messaggio eliminato",
        deletedByContactText: "🚫 Questo messaggio è stato eliminato dal contatto",
        deletedMessage: "🚫 _Messaggio eliminato_",
        reacted: "Hai reagito... {{reaction}}",
        editedAt: "Modificato {{time}}",
        empty: {
          startConversation: "Di' ciao al tuo nuovo contatto!"
        },
        dragDrop: {
          dropHere: "Rilascia il file qui"
        },
        facebookPolicy24h: "Hai 24 ore per rispondere dopo aver ricevuto un messaggio, in base alle politiche di Facebook."
      },
      messagesInput: {
        placeholderPrivateMessage: "Scrivi un messaggio o premi / per le risposte rapide",
        placeholderOpen: "Scrivi un messaggio o premi / per le risposte rapide",
        placeholderClosed: "Riapri o accetta questo ticket per inviare un messaggio.",
        failedToSendFiles: "Impossibile inviare {{count}} file: {{preview}}{{suffix}}",
        signMessage: "Firma",
        privateMessage: "Messaggio Privato"
      },
      contactDrawer: {
        header: "Dati del contatto",
        buttons: {
          edit: "Modifica contatto",
          block: "Blocca",
          unblock: "Sblocca"
        },
        extraInfo: "Altre informazioni"
      },
      messageVariablesPicker: {
        label: "Variabili disponibili",
        vars: {
          contactFirstName: "Nome",
          contactName: "Nome Completo",
          user: "Agente",
          greeting: "Saluto",
          protocolNumber: "Protocollo",
          date: "Data",
          hour: "Ora",
          ticket_id: "N° di Chiamata",
          queue: "Settore",
          connection: "Connessione"
        }
      },
      ticketOptionsMenu: {
        schedule: "Programmazione",
        delete: "Elimina",
        transfer: "Trasferisci",
        registerAppointment: "Osservazioni del Contatto",
        resolveWithNoFarewell: "Finalizza senza commiato",
        acceptAudioMessage: "Accettare audio dal contatto?",
        appointmentsModal: {
          title: "Osservazioni del Ticket",
          textarea: "Osservazione",
          placeholder: "Inserisci qui l'informazione che desideri registrare"
        },
        confirmationModal: {
          title: "Elimina il ticket del contatto",
          titleFrom: "del contatto ",
          message: "Attenzione! Tutti i messaggi relativi al ticket verranno persi."
        },
        buttons: {
          delete: "Elimina",
          cancel: "Annulla"
        }
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Annulla"
        }
      },
      messageInput: {
        tooltip: {
          signature: "Abilita/Disabilita Firma",
          privateMessage: "Abilita/Disabilita Messaggio Privato",
          meet: "Invia link per videoconferenza"
        },
        type: {
          imageVideo: "Foto e video",
          cam: "Fotocamera",
          contact: "Contatto",
          meet: "Videochiamata"
        }
      },
      messageOptionsMenu: {
        delete: "Elimina",
        reply: "Rispondi",
        edit: "Modifica",
        forward: "Inoltra",
        toForward: "Inoltra",
        talkTo: "Parla Con",
        react: "Reagisci",
        confirmationModal: {
          title: "Eliminare il messaggio?",
          message: "Questa azione non può essere annullata."
        }
      },
      invoices: {
        table: {
          invoices: "Fatture",
          details: "Dettagli",
          users: "Utenti",
          connections: "Connessioni",
          queue: "Code",
          value: "Valore",
          expirationDate: "Data Scadenza",
          action: "Azione"
        }
      },
      landing: {
        badge: "Piattaforma commerciale 3D",
        title: "Vendi, automatizza e scala su un'unica piattaforma",
        subtitle: "Centralizza WhatsApp, chiamate e follow-up con controllo in tempo reale.",
        nav: {
          benefits: "Benefici",
          market: "Mercato",
          pricing: "Prezzi",
          contact: "Contatto",
        },
        quickPills: {
          speed: "Risposte in secondi",
          control: "Controllo operativo giornaliero",
          conversion: "Piu chiusure per team",
        },
        servicesTitle: "Servizi base",
        services: {
          omnichannelTitle: "Supporto omnicanale",
          omnichannelDescription: "Unifica chat e chiamate in una sola inbox.",
          automationTitle: "Automazione intelligente",
          automationDescription: "Regole e flussi per rispondere senza attrito.",
          analyticsTitle: "Analisi commerciale",
          analyticsDescription: "Misura performance e conversione in tempo reale.",
          supportTitle: "Controllo operativo",
          supportDescription: "Assegna attivita e segui ogni opportunita.",
        },
        benefitsTitle: "Benefici chiave",
        benefitsSubtitle: "Gestisci tutto il flusso commerciale con meno passaggi e dati chiari.",
        benefits: {
          centralizedTitle: "Operazione centralizzata",
          centralizedDescription: "Messaggi, chiamate e task nella stessa vista.",
          responseTitle: "Risposta rapida",
          responseDescription: "Template e trigger per rispondere subito.",
          followupTitle: "Follow-up costante",
          followupDescription: "Promemoria e stati per non perdere opportunita.",
          visibilityTitle: "Visione in tempo reale",
          visibilityDescription: "Dashboard per attivita, funnel e conversione giornaliera.",
          teamworkTitle: "Lavoro di squadra",
          teamworkDescription: "Distribuisci conversazioni e bilancia il carico agenti.",
          governanceTitle: "Controllo e sicurezza",
          governanceDescription: "Permessi per ruolo e tracciabilita di ogni azione.",
        },
        market: {
          title: "Area marketplace",
          subtitle: "Attiva moduli per ogni fase e paga solo cio che ti serve.",
          items: {
            automationTitle: "Flussi e processi",
            automationDescription: "Automatizza vendite, supporto e post-vendita.",
            aiTitle: "IA commerciale",
            aiDescription: "Assistenti, prompt e risposte suggerite.",
            integrationsTitle: "Integrazioni",
            integrationsDescription: "Collega API, canali e strumenti esterni.",
            billingTitle: "Pagamenti e piani",
            billingDescription: "Gestisci abbonamenti, rinnovi e crescita.",
          },
          ctaHint: "Accedi per attivare moduli dal tuo pannello Mercato.",
          ctaButton: "Accedi e attiva moduli",
        },
        actions: {
          login: "Entra nell'applicazione",
          whatsapp: "Scrivi su WhatsApp",
          call: "Chiama ora",
        },
        contactLabel: "Contatto Klorum: {{number}}",
        redirectHint: "Tutti gli accessi della piattaforma reindirizzano al login sicuro.",
        footer: {
          rights: "Klorum {{year}}. Tutti i diritti riservati.",
          note: "Accesso commerciale tramite login sicuro.",
        },
      },
      marketplace: {
        title: "Mercato",
        hero: {
          title: "Mercato",
          subtitle: "Attiva addon e moduli per potenziare il tuo account."
        },
        stats: {
          active: "Attivi",
          available: "Disponibili",
          showing: "Mostrando"
        },
        search: {
          label: "Cerca",
          placeholder: "Es: Cataloghi, AI, Campagne..."
        },
        filters: {
          all: "Tutti",
          activeOnly: "Solo attivi",
          sort: {
            recommended: "Consigliati",
            nameAsc: "Nome (A-Z)",
            priceAsc: "Prezzo (basso)",
            priceDesc: "Prezzo (alto)"
          }
        },
        permissions: {
          manageOnly: "Solo admin/supervisor/superadmin puo attivare addon."
        },
        card: {
          key: "Chiave",
          active: "ATTIVO",
          inactive: "INATTIVO",
          noDescription: "Nessuna descrizione",
          category: "Categoria",
          includedInPlan: "Incluso nel tuo piano",
          customized: "Personalizzato",
          price: "Prezzo",
          free: "Gratis"
        },
        actions: {
          refresh: "Aggiorna",
          activate: "Attiva",
          deactivate: "Disattiva",
          restore: "Ripristina"
        },
        empty: {
          title: "Nessun add-on disponibile",
          subtitle: "Quando aggiorni il piano o un admin aggiunge addon, appariranno qui."
        }
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve esserci almeno un WhatsApp predefinito.",
        ERR_NO_DEF_WAPP_FOUND: "Nessun WhatsApp predefinito trovato. Verifica la pagina delle connessioni.",
        ERR_WAPP_NOT_INITIALIZED: "Questa sessione WhatsApp non è stata inizializzata. Verifica la pagina delle connessioni.",
        ERR_WAPP_CHECK_CONTACT: "Non è stato possibile verificare il contatto WhatsApp. Verifica la pagina delle connessioni",
        ERR_WAPP_INVALID_CONTACT: "Questo non è un numero WhatsApp valido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Non è stato possibile scaricare i media da WhatsApp. Verifica la pagina delle connessioni.",
        ERR_INVALID_CREDENTIALS: "Errore di autenticazione. Riprova.",
        ERR_SENDING_WAPP_MSG: "Errore nell'invio del messaggio WhatsApp. Verifica la pagina delle connessioni.",
        ERR_DELETE_WAPP_MSG: "Non è stato possibile eliminare il messaggio WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Esiste già un ticket aperto per questo contatto.",
        ERR_SESSION_EXPIRED: "Sessione scaduta. Accedi nuovamente.",
        ERR_USER_CREATION_DISABLED: "La creazione utente è stata disabilitata dall'amministratore.",
        ERR_NO_PERMISSION: "Non hai il permesso di accedere a questa risorsa.",
        ERR_DUPLICATED_CONTACT: "Esiste già un contatto con questo numero.",
        ERR_NO_SETTING_FOUND: "Nessuna impostazione trovata con questo ID.",
        ERR_NO_CONTACT_FOUND: "Nessun contatto trovato con questo ID.",
        ERR_NO_TICKET_FOUND: "Nessun ticket trovato con questo ID.",
        ERR_NO_USER_FOUND: "Nessun utente trovato con questo ID.",
        ERR_NO_WAPP_FOUND: "Nessun WhatsApp trovato con questo ID.",
        ERR_CREATING_MESSAGE: "Errore nella creazione del messaggio nel database.",
        ERR_CREATING_TICKET: "Errore nella creazione del ticket nel database.",
        ERR_FETCH_WAPP_MSG: "Errore nella ricerca del messaggio in WhatsApp, potrebbe essere troppo vecchio.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Questo colore è già in uso, scegline un altro.",
        ERR_WAPP_GREETING_REQUIRED: "Il messaggio di benvenuto è obbligatorio quando ci sono più di una coda.",
        ERR_OUT_OF_HOURS: "Fuori Orario di Servizio!"
      }
    }
  }
};

export { messages };
